import services from './Services';
import constants from './Constants';

class Tracker {

    constructor() {
      if (!services.segment) {
        /* eslint-disable no-console */
        console.error(
          'Tracker missing parameter,' +
          ' segment: ' + services.segment
        );
        /* eslint-enable no-console */
      }
    }

    openEnquiry(source) {
      const properties = Object.assign(
        {source: source},
        this._commonData()
      );

      const eventName = constants.events.OPEN_ENQUIRY;
      this._segmentTrack(eventName, properties);
    }

    submitEnquiry(source, formData) {
      const properties = Object.assign(
        {source: source, formData: formData},
        this._commonData()
      );
      const eventName = constants.events.SUBMIT_ENQUIRY;
      this._segmentTrack(eventName, properties);
    }

    confirmedEnquiry(source) {
      const properties = Object.assign(
        {source: source},
        this._commonData()
      );
      const eventName = constants.events.CONFIRMED_ENQUIRY;
      this._segmentTrack(eventName, properties);
    }

    enquiryValidationError(source, invalidFields) {
      const properties = Object.assign(
        {source: source, invalidFields: invalidFields},
        this._commonData()
      );
      const eventName = constants.events.ENQUIRY_VALIDATION_ERROR;
      this._segmentTrack(eventName, properties);
    }

    homePageView() {
      const properties = this._commonData();

      const pageName = constants.pages.HOME;
      this._segmentPage(pageName, properties);
    }

    searchPageView(additionalProperties) {
      const properties = Object.assign(
        additionalProperties,
        this._commonData(),
      );

      const pageName = constants.pages.SEARCH;
      this._segmentPage(pageName, properties);
    }

    homeListingPageView(additionalProperties) {
      const properties = Object.assign(
        additionalProperties,
        this._commonData()
      );

      const pageName = constants.pages.HOME_LISTING;
      this._segmentPage(pageName, properties);
    }

    _segmentTrack(eventName, properties) {
      if (services.segment) {
        services.segment.track(eventName, properties);
      }
    }

    _segmentPage(pageName, properties) {
      if (services.segment) {
        services.segment.page(pageName, properties);
      }
    }

    _commonData() {
      return {
        location: window.location.href,
        pageTitle: document.title,
      };
    }
}

export default new Tracker();



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/Tracker/Tracker.js
 **/